<template>
  <div v-if="isDisplayed" class="d-flex" :style="{ maxWidth, width: maxWidth }">
    <v-select
      :model-value="selectedValue"
      :items="items"
      item-title="text"
      item-value="value"
      variant="underlined"
      :placeholder="t('general.select')"
      hide-details
      hide-no-data
      flat
      single-line
      density="compact"
      :disabled="isDisabled"
      @update:model-value="update"
    />
  </div>
</template>

<script>
import { get } from 'lodash';
import { useInternationalization } from '@/composables/use-internationalization';

export default {
  setup() {
    const { t } = useInternationalization();
    return { t };
  },

  computed: {
    selectedValue() {
      return get(this.params, 'value', null);
    },

    items() {
      return get(this.params, 'items', []);
    },

    isDisplayed() {
      return get(this.params, 'isDisplayed', false);
    },

    isDisabled() {
      return get(this.params, 'isDisabled', false);
    },

    maxWidth() {
      return get(this.params, 'maxWidth', '100%');
    },
  },

  methods: {
    update(value) {
      this.params.setValue(value);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@style/base/_variables.scss';
</style>
